import { createReducer } from 'redux-create-reducer'
import {
  CLIENT_LIBRARY_CLIENTS_INVITE,
  CLIENT_LIBRARY_CLIENTS_INVITE_FAIL,
  CLIENT_LIBRARY_CLIENTS_INVITE_SUCCESS,
  CLIENT_LIBRARY_CLIENTS_RESET_ERRORS,
} from '@disco/constants/ActionTypes'
type LibraryClientsInvite = {
  errors: Record<string, any>
  inProgress: boolean
}
export type LibraryClientsInviteState = Readonly<LibraryClientsInvite>
const initialState: LibraryClientsInviteState = {
  errors: {},
  inProgress: false,
}
export const libraryClientsInviteReducer = createReducer<
  LibraryClientsInviteState,
  any
>(initialState, {
  [CLIENT_LIBRARY_CLIENTS_INVITE](state: LibraryClientsInviteState) {
    return { ...state, inProgress: true }
  },

  [CLIENT_LIBRARY_CLIENTS_INVITE_SUCCESS](state: LibraryClientsInviteState) {
    return { ...state, inProgress: false }
  },

  [CLIENT_LIBRARY_CLIENTS_INVITE_FAIL](
    state: LibraryClientsInviteState,
    { error }: Record<string, any>,
  ) {
    return { ...state, errors: error, inProgress: false }
  },

  [CLIENT_LIBRARY_CLIENTS_RESET_ERRORS]() {
    return initialState
  },
})
